import crCities from '../../data/cr.mjs';

export const CITY_POOL = crCities.filter(city => {
    return Number.isFinite(city.latitude) && Number.isFinite(city.longitude) && city.obec && city.okres && city.kraj;
});

export const KRAJ_NAMES = Array.from(new Set(CITY_POOL.map(city => city.kraj))).sort((a, b) => a.localeCompare(b, 'cs'));
export const OKRES_NAMES = Array.from(new Set(CITY_POOL.map(city => city.okres))).sort((a, b) =>
    a.localeCompare(b, 'cs'),
);
